import styles from './page.module.css';
import GoAuraConsentToggle from "./GoAura/GoAuraConsentToggle";
import SellerSnapConsentToggle from './SellerSnap/SellerSnapConsentToggle';
import BqoolConsentToggle from './Bqool/BqoolConsentToggle';

export default function IntegrationPage() {
  return (
    <div className={styles.container}>
      <BqoolConsentToggle />
      <GoAuraConsentToggle />
      <SellerSnapConsentToggle />
    </div>
  );
}   